export default {
	prepareSequenceImages: Array(31)
		.fill('')
		.map((v, i) =>
			require(`../../../Box_sequences/00_TV terrace new_box/terracenew_box${i < 10 ? `0${i}` : i}.jpg`)
		),
	designSliderImage: require('../../../product drawing/tessllate.png'),
	designImageList: [
		{
			number: 1,
			side: 'SIDE',
			sideNumber: '1',
			image: require('../../../parts/tessllate/Tessellate01.png'),
		},
		{
			number: 2,
			side: 'TOP',
			sideNumber: '&',
			side2: 'BOTTOM',
			image: require('../../../parts/tessllate/Tessellate02.png'),
		},
		{
			number: '',
			text: '',
			image: require('../../../parts/tessllate/Tessellate03.png'),
		},
		{
			number: 3,
			side: 'SIDE',
			sideNumber: '2',
			image: require('../../../parts/tessllate/Tessellate04.png'),
		},
		{
			number: 4,
			side: 'MIDDLE',
			image: require('../../../parts/tessllate/Tessellate05.png'),
		},
	],
	cutOutPartsImage: require('../../../parts/tessllate/Tessellate06.png'),
	cutOutPartsFoldImage: require('../../../parts/tessllate/Tessellate07.png'),
	assembleSequenceImages: Array(60)
		.fill('')
		.map((v, i) =>
			require(`../../../sequences/13_Tessellate_sequence/Tessellate${
				i < 10 ? `0${i}` : i
			}.jpg`)
		),
	completeImage: require('../../../complete/Tessellate-01.jpg'),
	completeImagePc: require('../../../complete/Tessellate-01.jpg'),
};
